
import common from './th_TH/common'
import areaCode from './th_TH/areaCode'
import communicateCenter from './th_TH/communicateCenter'
import components from './th_TH/components'
import course from './th_TH/course'
import courseDetail from './th_TH/courseDetail'
import examDetail from './th_TH/examDetail'
import home from './th_TH/home'
import humanTraining from './th_TH/humanTraining'
import inforList from './th_TH/inforList'
import Information from './th_TH/Information'
import intelligentOfficialDoc from './th_TH/intelligentOfficialDoc'
import knowledgeLib from './th_TH/knowledgeLib'
import LearnRecords from './th_TH/LearnRecords'
import Login from './th_TH/Login'
import myCourse from './th_TH/myCourse'
import myExam from './th_TH/myExam'
import mynews from './th_TH/mynews'
import mySetting from './th_TH/mySetting'
import mytopic from './th_TH/mytopic'
import myTrainingClass from './th_TH/myTrainingClass'
import myTrainingDetail from './th_TH/myTrainingDetail'
import myWork from './th_TH/myWork'
import post from './th_TH/post'
import postDetail from './th_TH/postDetail'
import practiceTrain from './th_TH/practiceTrain'
import publicExam from './th_TH/publicExam'
import questionnaire from './th_TH/questionnaire'
import rules from './th_TH/rules'
import search from './th_TH/search'
import studyMap from './th_TH/studyMap'
import topic from './th_TH/topic'
import topicDetail from './th_TH/topicDetail'
import topicManagerRange from './th_TH/topicManagerRange'
import trainingClass from './th_TH/trainingClass'
import trainingCourseDetail from './th_TH/trainingCourseDetail'
import webLive from './th_TH/webLive'

export default {
  ...common,
  ...areaCode,
  ...communicateCenter,
  ...components,
  ...course,
  ...courseDetail,
  ...examDetail,
  ...home,
  ...humanTraining,
  ...inforList,
  ...Information,
  ...intelligentOfficialDoc,
  ...knowledgeLib,
  ...LearnRecords,
  ...Login,
  ...myCourse,
  ...myExam,
  ...mynews,
  ...mySetting,
  ...mytopic,
  ...myTrainingClass,
  ...myTrainingDetail,
  ...myWork,
  ...post,
  ...postDetail,
  ...practiceTrain,
  ...publicExam,
  ...questionnaire,
  ...rules,
  ...search,
  ...studyMap,
  ...topic,
  ...topicDetail,
  ...topicManagerRange,
  ...trainingClass,
  ...trainingCourseDetail,
  ...webLive
}
